<template>
  <div class="mt-6 mx-6 flex flex-col w-auto overflow-hidden">
    <div
      class=" w-full flex flex-row justify-between p-4 px-4 border rounded-md
      border-blue-500"
    >
      <breadcrumbs :links="links"></breadcrumbs>
      
      <div>
        <div
          class="flex flex-row p-1 bg-gray-100 rounded-md border
          border-gray-150 narrative-menu"
        >
          <social-share-menu 
            :collapsable="true" 
            :resourceUrl="getNarrativeUrl()"
            :resourceTitle="narrative.name"
            :resourceDescription="narrative.description"
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="h-8 w-8 mt-1 mr-4 text-blue-500 cursor-pointer"
            v-tooltip="'Preview'"
            @click="
              $router.push({
                name: 'WatchNarrative',
                params: { username: username, narrativeName: narrativeName },
              })
            "
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1
                1H5a1 1 0 01-1-1V4z"
            />
          </svg>
          <!-- </router&#45;link> -->

        </div>
      </div>
    </div>

    <main class="flex flex-row mt-6" id="page-holder">
      <section class="w-1/3 ">
        <time-line :narrative="narrative"></time-line>
      </section>

      <section class="ml-4 w-2/3 flex flex-row">
        <streaming-content
          :narrative="narrative"
          :debug-mode="debugMode"
        ></streaming-content>
      </section>

      <section class="ml-4 w-2/3 flex flex-row relative" v-if="false">
        <!-- CONTAINERS FOR BACKGROUND IMAGES/VIDEOS -->
        <div
          v-for="(e, idx) in narrative.elements"
          :id="e.Oid + '-container'"
          style="z-index: -1; opacity: 0.1"
          v-if="e.type == 'IMAGE' && e.isBackground"
        >
          <img
            :src="e.url"
            style="position: absolute; top:0; left: 0; height:100%; width:
            100%; opacity: 1; z-index:-1; object-fit:cover; object-position:
            50% 50%"
          />
        </div>
        <!-- SCROLLABLE CONTENT -->
        <div
          id="streamCanvas"
          ref="streamCanvas"
          class="w-full preview rounded-md border border-gray-300
          overflow-scroll"
        >
          <stream
            :key="updates"
            :narrative="narrative"
            v-on:ready="reset"
          ></stream>
          <!-- <watch :narrative="narrative" :container="$refs.preview"></watch> -->
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { EventBus } from "@/utils.js";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import ElementBlock from "@/components/ElementBlock.vue";
import TimeLine from "./components/TimeLine.vue";
import SocialShareMenu from '@/views/Narratives/components/SocialShareMenu.vue';
import draggable from "vuedraggable";
import CWarning from "@/components/Core/CWarning";
import Watch from "@/views/Narratives/Watch.vue";
import Stream from "@/views/Narratives/Stream.vue";
import StreamingContent from "@/views/Narratives/StreamingContent";

export default {
  components: {
    Breadcrumbs,
    ElementBlock,
    SocialShareMenu,
    draggable,
    TimeLine,
    CWarning,
    Watch,
    Stream,
    StreamingContent,
  },

  props: ["username", "narrativeName"],

  data() {
    return {
      debugMode: false,
      updates: 0,
      controller: null,
      list: [],
      originUrl: ''
    };
  },

  watch: {
    // narrative: {
    //   // When we update the narrative, rebuild the narrative stream.
    //   deep: true,
    //   handler() {
    //     setTimeout(this.rebuild, 500);
    //   },
    // },
  },

  methods: {
    toggleDebug() {
      this.debugMode = !this.debugMode;
      // this.rebuild();
    },
    createController() {
      // This generates the narrative...
      if (this.controller) {
        this.controller.reset();
      }
      this.controller = new Narrative({
        targetRef: this.$refs.streamCanvas,
        scrollmagic: this.$scrollmagic,
        narrative: this.narrative,
        debugMode: this.debugMode,
      });
    },

    rebuild() {
      // let myguy = document.getElementById("changer");
      // this.$refs.streamCanvas.$scrollmagic.scrollTo(myguy);
      this.controller.reset();
      this.updates += 1;
    },

    reset() {
      this.createController();
      this.controller.create();
    },

    editElement(element) {
      this.$router.push({
        name: "EditElement",
        params: {
          username: this.username,
          narrativeName: this.narrativeName,
          elementId: element.Oid,
        },
      });
    },

    getNarrativeUrl() {
      const props = this.$router.resolve({
        name: 'WatchNarrative',
        params: { username: this.username, narrativeName: this.narrativeName },
      });

      return `${this.originUrl}/${props.href}`;
    }
  },

  computed: {
    links() {
      return [
        {
          name: this.$store.getters['users/nickname'] + "'s narratives",
          route: {
            name: "Narratives",
            params: { username: this.username },
          },
        },
        {
          name: this.narrativeName,
          route: {
            name: "Narrative",
            params: {
              username: this.username,
              narrativeName: this.narrativeName,
            },
          },
        },
      ];
    },

    narrative() {
      return this.$store.state.narratives.current;
    },
  },

  created() {
    this.originUrl = window.location.origin;
  },

  mounted() {
    let details = {
      username: this.username,
      narrativeName: this.narrativeName,
    };
    this.$store.dispatch("narratives/getNarrative", details);
    // Attach scrollmagic to target element
    // this.$scrollmagic.attachTo(this.$refs.streamCanvas);
    // this.$refs.streamCanvas.$scrollmagic.addScene(scene);
    // var scrollmagic = this.$scrollmagic;
  },
};
</script>

<style>
.preview {
  overflow: scroll;
  height: 600px;
}
.downscale {
  transform: scale(0.7, 0.7);
  transform-origin: 0, 0;
}
.activeClass {
  color: "red" !important;
}

.narrative-menu {
  align-items: center;
}
</style>
